<script type="text/ecmascript-6">
    import DesignerQuestionGlassDesign from "./DesignerQuestionGlassDesign.vue";
    import SynsealQuestion from "../mixin/synseal/Question.vue";

    export default {
        mixins: [
            DesignerQuestionGlassDesign,
            SynsealQuestion,
        ],
        props: {
            title: {
                default(){
                    return 'Door Glass Design';
                }
            },
        }
    }
</script>
